export const FIELDS = {
  SUBSCRIBER_NUMBER: 'numAbo',
  DECODER_NUMBER: 'numCard',
  EMAIL: 'email',
  PASSWORD: 'password',
  PASSWORD_CONFIRMATION: 'passwordConfirmation',
  COUNTRY_CODE: 'countryCode'
};
